<template>
  <v-navigation-drawer
    app
    color="secondary"
    dark
    :mini-variant="collapsed"
    mini-variant-width="88"
    width="320"
    disable-route-watcher
    permanent
  >
    <v-list nav dense class="px-4 d-flex flex-column align-center">
      <nav-item
        :collapsed="collapsed"
        icon="home"
        title="Reviews"
        to="/reviews"
        cypress-id="reviews-nav-item"
      />
      <nav-item
        v-if="isSuperAdmin"
        :collapsed="collapsed"
        icon="admin_panel_settings"
        title="Admin"
        to="/admin"
        cypress-id="admin-nav-item"
      />
      <template v-if="reviewSelected">
        <v-divider class="divider mb-4" />
        <nav-item
          :collapsed="collapsed"
          icon="dashboard"
          title="Review"
          :to="`/review/${reviewId}`"
        />
        <nav-item
          :collapsed="collapsed"
          icon="cloud_upload"
          title="Uploads"
          :to="`/review/${reviewId}/uploads`"
        />
        <nav-item
          :collapsed="collapsed"
          icon="thumb_up_alt"
          title="Screening"
          :to="`/review/${reviewId}/screening`"
        />
        <nav-item
          :collapsed="collapsed"
          icon="find_in_page"
          title="Full Text Review"
          :to="`/review/${reviewId}/full-text-review`"
        />
        <nav-item
          :collapsed="collapsed"
          icon="list_alt"
          title="Data Extraction"
          :to="`/review/${reviewId}/data-extraction`"
        />
      </template>
    </v-list>
    <template #append>
      <v-row no-gutters justify="end">
        <expansion-button :collapsed="collapsed" @click="toggle" />
      </v-row>
      <user-controls
        :researcher="researcher"
        :collapsed="collapsed"
        @logout="$emit('logout')"
      />
    </template>
  </v-navigation-drawer>
</template>

<script>
import NavItem from '@/components/AppBar/NavItem';
import ExpansionButton from '@/components/AppBar/ExpansionButton';
import UserControls from '@/components/AppBar/UserControls';
import { Researcher } from '@/models';

export default {
  name: 'AppBar',
  components: {
    NavItem,
    ExpansionButton,
    UserControls,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    researcher: {
      type: Researcher,
      default: null,
    },
  },
  computed: {
    collapsed: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    hasResearcher() {
      return !!this.researcher;
    },
    isSuperAdmin() {
      return this.researcher && this.researcher.isSuperAdmin;
    },
    reviewSelected() {
      return !!this.routeParams.reviewId;
    },
    reviewId() {
      return this.routeParams.reviewId;
    },
    routeParams() {
      return (this.$route || {}).params || {};
    },
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>

<style lang="scss" scoped>
.divider {
  width: 100%;
  border-color: #7687b0 !important;
}
</style>
